import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ActivatedRoute,
  NavigationEnd,
  ParamMap,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterModule,
  RouterOutlet,
} from '@angular/router';
import { routes } from './app.routes';
import { StoreService } from './services/store/store.service';
import { IAppParams, IUserInfo, Products } from './interfaces/state-interface';
import { AppService } from './services/app.service';
import { AuthService } from './services/auth/auth.service';
import { CookiesService } from './services/cookies/cookies.service';
import { WelcomeViewComponent } from './shared/components/welcome-view/welcome-view.component';
import { NS_Enums } from './static/namespace';
import { TrackingService } from './services/tracking/tracking.service';
import { filter } from 'rxjs';
import * as Sentry from '@sentry/angular';
import { SentryService } from './services/sentry/sentry.service';
import { PosthogService } from './services/posthog/posthog.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    WelcomeViewComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'accounts';
  product: Products;
  userInfo: IUserInfo;
  maintenanceMode:boolean = false;
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private appService: AppService = inject(AppService);
  private authService: AuthService = inject(AuthService);
  private store: StoreService = inject(StoreService);
  private trackingService: TrackingService = inject(TrackingService);
  private storeService: StoreService = inject(StoreService);
  private posthogService: PosthogService = inject(PosthogService);
  private sentryService: SentryService = inject(SentryService);

  // private sharedCookieInterval: any = null;

  showWelcomeView: boolean = false;

  constructor(){
    inject(Sentry.TraceService);
    this.trackingService.init();
    this.posthogService.init();
  }

  ngOnInit() {
    // this.authService.init();
    this.router.initialNavigation();
    this.store.init();

    this.welcomeViewHandler();
    this.route.queryParamMap.subscribe(qp => {
      this.product = (
        qp.get('productName') ||
        qp.get('productType') ||
        Products.SARAS
      ).toUpperCase() as Products;
    
      this.storeService.setProduct(
        Products[this.product] || Products.SARAS
      );
      this.appService.setProductType(this.product);
    });


    this.authService.pollSharedCookieStatus();

    this.appService.$maintenanceMode.subscribe((value)=>{
      this.maintenanceMode = value;
    })
    this.storageSubscription();
    this.initSentryUserInfo();
  }

  private initSentryUserInfo(): void {
    const userDetails: IUserInfo = this.store.getUser();
    if (userDetails?.userId || userDetails?.company?.companyId) {
      this.sentryService.setUserInfo({
        userId: userDetails?.userId,
        companyId: userDetails?.company?.companyId,
      });
      this.posthogService.identify({
        userId: userDetails?.userId,
        companyId: userDetails?.company?.companyId,
      });
    }
  }

  /* SUBSCRIPTION to local storage event
    IDENTIFY PAGE IN OTHER TAB IS LOGGED OUT OR LOGGED IN
  */
  storageSubscription(){
    window.addEventListener('storage', (event)=>{
      if (event.key === NS_Enums.cacheKeysEnum.saras_global_portal) {
        const newVal = this.store.getSarasPortalData();
        if(newVal === 'LOGIN'){
          this.router.navigate(['/products'])
        }else if(newVal === 'LOGOUT'){
          this.store.setSarasPortalData('');
          setTimeout(()=>{
            this.router.navigate(['/login'], {queryParams: {'productType': this.product.toLowerCase()}})
          }, 2000);
        }
      }
    }, false);
  
  }


  welcomeViewHandler(){
    this.appService.$showWelcomeView.subscribe((val)=>{
      this.showWelcomeView = val || false;
    })
  }
}
